import { Check, Circle, PlayCircle, type LucideIcon } from 'lucide-react';

export interface StatusConfigItem {
  icon: LucideIcon;
  label: string;
  color: string;
  bgColor: string;
}

export type TodoStatus = 'pending' | 'in_progress' | 'completed';

export const TODO_STATUS_CONFIG: Record<TodoStatus, StatusConfigItem> = {
  pending: {
    icon: Circle,
    label: 'Pending',
    color: 'text-foreground dark:text-foreground-dark',
    bgColor: 'bg-muted/50',
  },
  in_progress: {
    icon: PlayCircle,
    label: 'In Progress',
    color: 'text-blue-600 dark:text-blue-400',
    bgColor: 'bg-blue-100 dark:bg-blue-900/30',
  },
  completed: {
    icon: Check,
    label: 'Completed',
    color: 'text-green-600 dark:text-green-400',
    bgColor: 'bg-green-100 dark:bg-green-900/30',
  },
};
